import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { FuseSharedModule } from '@fuse/shared.module';

import { TabApprovalsEquipmentsCustomFieldsComponent } from './tab-approvals-equipments-custom-fields.component';

@NgModule({
    declarations: [
        TabApprovalsEquipmentsCustomFieldsComponent
    ],
    imports     : [
        FuseSharedModule,

        MatInputModule,
        MatIconModule,
    ],
    exports: [
        TabApprovalsEquipmentsCustomFieldsComponent
    ]
})
export class TabApprovalsEquipmentsCustomFieldsModule { }
